import { Strategy } from '@oai-frontend-monorepo/types';
import { calculateChange } from '../../../math/calculateChange';
import { strategyIsCredit } from '../../strategy/strategyIsCredit';

type Params = {
  oldValue?: number;
  newValue?: number;
  strategy?: Strategy;
  quantity?: number;
};

const calculatePositionChange = ({
  oldValue,
  newValue,
  strategy,
  quantity = 1,
}: Params) => {
  if (!strategy) {
    return undefined;
  }

  let change = calculateChange({
    oldValue,
    newValue,
  });

  if (change === undefined) {
    return change;
  }

  const isStock =
    strategy === Strategy.LONG_STOCK || strategy === Strategy.SHORT_STOCK;

  const multiplier = isStock ? 1 : 100;

  change = change * quantity * multiplier;

  if (strategyIsCredit(strategy)) {
    return change * -1;
  }

  return change;
};

export default calculatePositionChange;
